import { useLazyQuery } from "@apollo/client";
import {
  QUERY_SEASONS,
  QUERY_EVENTS_FOR_SEASON,
  QUERY_SESSIONS_FOR_EVENT,
} from "../queries/eventManagementQueries";

export function QuerySeasons() {
  const [querySeasons, { data, loading, error }] = useLazyQuery(QUERY_SEASONS);
  if (error) {
    console.log(error);
  }
  return {
    querySeasons: () => querySeasons(),
    seasons: data?.getSeasons
      ? [...data.getSeasons].reverse()
      : data?.getSeasons,
    loading,
    error,
  };
}

export function QueryEventsForSeason() {
  const [queryEventsForSeason, { data, loading, error }] = useLazyQuery(
    QUERY_EVENTS_FOR_SEASON,
  );
  if (error) {
    console.log(error);
  }
  return {
    queryEventsForSeason: (season: number) =>
      queryEventsForSeason({ variables: { season } }),
    events: data?.getEventsForSeason
      ? [...data.getEventsForSeason].reverse()
      : data?.getEventsForSeason,
    loading,
    error,
  };
}

export function QuerySessionsForEvent() {
  const [querySessionsForEvent, { data, loading, error }] = useLazyQuery(
    QUERY_SESSIONS_FOR_EVENT,
  );
  if (error) {
    console.log(error);
  }
  return {
    querySessionsForEvent: (eventCode: string) =>
      querySessionsForEvent({ variables: { eventCode } }),
    sessions: data?.getSessionsForEvent
      ? [...data.getSessionsForEvent].reverse()
      : data?.getSessionsForEvent,
    loading,
    error,
  };
}
